<template>
  <div class="store-profile">
    <div class="profile-header">
      <img src="man.png">
    </div>
    <h3 class="store-name">Zapata</h3>
    <div class="store-location">
      <img class="location-icon" src="/location.svg">
      <div class="location-item">Av. Division del Nte. 2008</div>
    </div>
    <!-- <div class="store-stat">
      <div class="stat-value">128m</div>
      <div class="stat-description">ventas del periodo</div>
    </div>
    <div class="store-stat">
      <div class="stat-value">$6528</div>
      <div class="stat-description">comisiones del periodo</div>
    </div> -->
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
.store-profile {
  width: 100%;
  border-radius: 6px;
  padding: 24px 20px;
  box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.25);
  background-color: white;
}
.store-name {
  font-size: 32px;
  margin-top: 24px;
}
.profile-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.store-location {
  margin: 16px 0;
  display: flex;
}
.store-stat {
  margin-top: 20px;
}
.stat-value {
  font-size: 24px;
}
.location-icon {
  width: 14px;
  height: auto;
  margin-right: 5px;
}
.level-text {
  padding: 4px 0 4px 16px;
}
.level {
  border-top-right-radius: 100px;
  border-bottom-right-radius: 100px;
  padding: 4px 16px 4px 12px;
  margin-left: 12px;
  background-color: darken(#51bae3, 10%);
}
</style>
